import { useTranslation } from "react-i18next";

import { AlertCircleIcon } from "~/components/ui/icons/alert-circle";
import { TruckIcon } from "~/components/ui/icons/truck";
import { OrderTagShipment } from "~/graphql/graphql-new.gen";
import type { OrderQuery } from "~/graphql/graphql-new.gen";

import { OrderBadge } from "../order-status-badge/order-badge";
import {
  getOrderShipmentLabelFromTag,
  orderShipmentVariant,
} from "../order-status-badge/order-shipment-badge";

export const OrderShipmentBadge: React.FC<{
  hasTrackingStucked: OrderQuery["order"]["parcels"][number]["hasTrackingStucked"];
  isCancelled?: boolean;
  tag: OrderTagShipment;
  trackingSubStatus: OrderQuery["order"]["parcels"][number]["trackingSubStatus"];
}> = ({ hasTrackingStucked, isCancelled, tag, trackingSubStatus }) => {
  const { t } = useTranslation();

  if (tag === OrderTagShipment.None) return null;

  const variantStyle = orderShipmentVariant(
    {
      isCancelled,
      hasTrackingStucked,
      tag,
      trackingSubStatus,
    },
    "filled",
  );

  return (
    <OrderBadge variant={variantStyle} intent="bold">
      <div className="flex flex-nowrap items-center gap-x-1">
        {variantStyle === "danger" || variantStyle === "warning" ? (
          <AlertCircleIcon className="size-3.5" />
        ) : (
          <TruckIcon className="size-3.5" />
        )}
        <span className={isCancelled ? "line-through" : ""}>
          {getOrderShipmentLabelFromTag(tag, t)}
        </span>
      </div>
    </OrderBadge>
  );
};
